import { render, staticRenderFns } from "./invite-setting.vue?vue&type=template&id=4aa960ec&scoped=true";
import script from "./invite-setting.vue?vue&type=script&lang=js";
export * from "./invite-setting.vue?vue&type=script&lang=js";
import style0 from "./invite-setting.vue?vue&type=style&index=0&id=4aa960ec&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "4aa960ec", null);
export default component.exports;